import DOMAIN_ACTIONS_MAP from '@/common/store/modules/domains/domains.notificationsMap';
import { checkIsInActionsMap } from '@/common/utils/actionMapsMethods';

export default {
  socket_domain(store, event) {
    const { commit, rootState } = store;
    const { $can } = this;

    const errorMessage = checkIsInActionsMap({ state: rootState, event, actionsMap: DOMAIN_ACTIONS_MAP, $can });

    if (errorMessage) {
      return commit('errors/ADD_ERROR', { message: errorMessage, data: event }, { root: true });
    }

    const { action = 'dispatch', actionName, payloadFormatter = it => it } = DOMAIN_ACTIONS_MAP[event.type][event.operation];

    return this[action](actionName, payloadFormatter(event.object), { root: true });
  },
  FETCH_PROPS({ commit }) {
    return this.$api.get('/api/v2/domains/props/')
      .then((data) => {
        commit('SET_DOMAINS_PROPS', data.data);

        return data;
      })
      .catch((error) => {
        commit('SET_ERRORS', error);

        throw error;
      });
  }
};
